module.exports = __webpack_public_path__ + "static/media/triangle-music.8cdb6e81.svg";